<template>
  <div>
    <headline code="titre-soumission"></headline>
    <ressource code="texte-soumission" hide-if-empty></ressource>

    <!-- Section Engagement fusionnée -->
    <v-form v-model="valid" ref="mainForm" class="mt-6">
      <opq-case
        code="declaration"
        v-model="sas.sasInscriptionAuTableauRegistre.declarationFinDeFormulaire"
        :live="liveSasInscriptionTableauRegistre(2323)"
      ></opq-case>
    </v-form>

    <div class="mt-6">
      <v-btn x-large dark color="#3a3838" @click="submit">Soumettre</v-btn>
    </div>
    <opq-alert type="warning" class="mt-6" code="formulaire-incomplet" max-width="700" v-show="showAlert"></opq-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],

  props: {
    showAlert: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(["sas"]),
  },

  methods: {
    submit() {
      this.$emit("submit")
    },

    liveSasInscriptionTableauRegistre(cle) {
      return {
        endpoint: "sas-inscriptions-tableau-registre",
        cle: cle,
        fileId: this.sas.sasInscriptionAuTableauRegistre.id,
      }
    },
  },
}
</script>

<style></style>
